// extracted by mini-css-extract-plugin
export default {"ag-styles":"P_g","alert":"P_dJ","info":"P_dK","flag":"P_dL"};